import { c as _c } from "react/compiler-runtime";
import { US_STATES_AND_ARMED_FORCES } from '@onefootprint/core';
import { Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import TemplatedText from '../../../components/templated-text';
import type { CustomQuestionsFormData } from '../../../types';
import { previewLabel } from '../../../utils/preview-label';
type AddressPreviewProps = {
  questionIndex: number;
};
const AddressPreview = t0 => {
  const $ = _c(17);
  const {
    questionIndex
  } = t0;
  const {
    control
  } = useFormContext();
  const t1 = `questions.${questionIndex}.label`;
  const t2 = `questions.${questionIndex}.required`;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = [t1, t2];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== control || $[4] !== t3) {
    t4 = {
      control,
      name: t3
    };
    $[3] = control;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const [label, required] = useWatch(t4);
  let t5;
  if ($[6] !== label || $[7] !== required) {
    t5 = previewLabel(label, required, _temp);
    $[6] = label;
    $[7] = required;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const labelWithOptional = t5;
  let t6;
  if ($[9] !== labelWithOptional) {
    t6 = labelWithOptional && <div className="text-label-2 text-primary"><TemplatedText value={labelWithOptional} /></div>;
    $[9] = labelWithOptional;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = `questions.${questionIndex}.preview`;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      country: "Select a country",
      addressLine1: "Enter street address",
      addressLine2: "Enter apartment, suite, etc. (optional)",
      city: "Enter city",
      state: "Select state",
      zip: "Enter ZIP code or postal code"
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7) {
    t9 = <Form.AddressLines prefix={t7} stateOptions={US_STATES_AND_ARMED_FORCES} placeholders={t8} />;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t6 || $[15] !== t9) {
    t10 = <div className="flex flex-col gap-4">{t6}{t9}</div>;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export default AddressPreview;
function _temp(trimmed) {
  return `${trimmed} (Optional)`;
}